import http from "./httpService";

const apiEndpoint ="/api/statusreports";


function get(_id){
    return http.get(apiEndpoint+"/"+_id);
}

function getList(){
    return http.get(apiEndpoint+"/list");
}



export default  {get, getList};